import Button from 'mrf/view/Button';
import React from 'react';
import { Grid, Col } from 'mrf/view/Grid';
import Select from './Select';
import T from 'mrf/utils/T';
import { useFormFullSelector } from 'mrf/redux/ReduxHelper';
import Flex from 'mrf/layout/Flex';
import Tooltip from './Tooltip';
import { CsvIcon } from 'styles/components/Icons';
import { renderTableCell } from './FetcherObjectTable';
import IF from './IF';
import store from 'mrf/redux/store';
import useMRFTranslation from 'mrf/utils/useMRFTranslation';
import moment from 'moment';
import FileSaver from 'file-saver';

const cleanUpForCsv = obj => {
    if (typeof obj == "string" ) {
        return obj.replace ? obj.replace('"', '\\"') : obj;
    } else if (!isNaN(obj)) {
        return obj;
    } else {
        return ""
    }
}

const exportCsvCallback = (t, filePrefix, fields, list, byId) => {
    const { resources } = store.getState();
    const csvLines = [];

    const headerLine = fields
        .map(f => f.name)
        .map(cleanUpForCsv);

    csvLines.push(`"${headerLine.join('","')}"`);

    for (let i=0; i<list.length; ++i) {
        const obj = byId[list[i]];

        const csvLine = fields
            .map(field => renderTableCell({
                t,
                resources,
                idx: i,
                obj,
                field,
            }))
            .map(cleanUpForCsv);

        csvLines.push(`"${csvLine.join('","')}"`);
    }

    if (!filePrefix) {
        filePrefix = ""
    }

    const blob = new Blob([ csvLines.join('\n') ], {type: "text/plain;charset=utf-8"});
    const currentTimestamp = moment(new Date()).format("YYYYMMDDhhmm");
    FileSaver.saveAs(blob, `${filePrefix}${currentTimestamp}.csv`);
}

export default function Pagination({ context, fields, list, byId, showCsvButton, csvFilePrefix }) {
    const t = useMRFTranslation()

    const { data: form, set: setFormValue } = useFormFullSelector(context);

    const handleClickGotoFirstPage = () => {
        setFormValue({ fetch: true, page: 0 });
    }

    const handleClickPrevPage = () => {
        if (form?.page > 0) {
            setFormValue({ fetch: true, page: form.page - 1 });
        }
    }

    const handleClickNextPage = () => {
        if (form?.page < form?.pageCount - 1) {
            setFormValue({ fetch: true, page: form.page + 1 });
        }
    }

    const handleClickGotoLastPage = () => {
        setFormValue({ fetch: true, page: form.pageCount - 1 });
    }

    return (
        <Flex>
            <Grid
                justify='between'
                className='w-full px-4 py-1 border-t-2 rounded-b-lg shadow-md bg-paper text-color-light'
            >
                <Col size={6} sm={6} justify='end' className='inline-flex'>
                    <Flex>
                        <p><T>Rows per page</T>:</p>
                        <Select
                            className='pl-2 pt-0 pb-0 ml-1'
                            width='auto'
                            size='small'
                            context={context}
                            field='pageSize'
                        >
                            <option value='5'>5</option>
                            <option value='8'>8</option>
                            <option value='10'>10</option>
                            <option value='20'>20</option>
                            <option value='40'>40</option>
                            <option value='80'>80</option>
                        </Select>
                    </Flex>
                </Col>
                <Col size={6} sm={6} justify='end'>
                    <Grid cols={6} gap={0} justify='center'>
                        <IF condition={!!showCsvButton}>
                            <Tooltip content='Export CSV'>
                                <CsvIcon size={30} onClick={() => exportCsvCallback(t, csvFilePrefix, fields, list, byId)} id='exportCsv' />
                            </Tooltip>
                        </IF>
                        <Button noTranslate size='small' onClick={handleClickGotoFirstPage}>{'<<'}</Button>
                        <Button noTranslate size='small' onClick={handleClickPrevPage}>{'<'}</Button>
                        <span>{form?.page + 1} - {form?.pageCount > 0 ? form?.pageCount : 1}</span>
                        <Button noTranslate size='small' onClick={handleClickNextPage}>{'>'}</Button>
                        <Button noTranslate size='small' onClick={handleClickGotoLastPage}>{'>>'}</Button>
                    </Grid>
                </Col>
            </Grid>
        </Flex>
    );
}
